import request from '@hotmart/request'

import { getSideMenu, getGuideTour, fetchUserTypeInfo } from 'src/modules/context/context.service'
import { CONTEXT_REQUEST_IDENTIFIERS, CONTEXT_BAR_TYPES } from '../context.constants'
import ContextVO from './context.vo'
import '../context.requests'

export default class ContextDAO {
  async get(): Promise<ContextVO> {
    const contextData = [
      request(CONTEXT_REQUEST_IDENTIFIERS.MAIN_MENU),
      request(CONTEXT_REQUEST_IDENTIFIERS.MAIN_BAR),
      getSideMenu(),
      getGuideTour(),
      fetchUserTypeInfo()
    ]

    const [mainMenuResponse, mainBarResponse, sideMenuResponse, guideTourResponse, userTypeInfo] = await Promise.all(
      contextData
    )

    const context: ContextVO = {
      dynamicMenu: mainMenuResponse,
      barType: mainBarResponse?.barType || CONTEXT_BAR_TYPES.REGULAR,
      sideMenu: sideMenuResponse,
      guideTour: guideTourResponse,
      showGuideTourHotmartPRO: false,
      userTypeInfo
    }

    return context
  }
}
